import {
    PolarArea
} from 'vue-chartjs'

export default {
    extends: PolarArea,
    props: {

        chartdata: {
            type: Object,
            default: null
        },
        options: {
            type: Object,
            default: null
        },

    },
    
    mounted() {
        // this.options["onClick"] = this.handle;
        this.renderChart(this.chartdata, this.options)
    }
}
